<template>
  <q-page padding>
    <div class="row col-12 justify-between align-center">
      <p class="text-h6 text-brand-1 text-weight-bolder">
        Consulta de Produtos
      </p>
    </div>
    <div>
      <div class="row text-brand-5 text-weight-bold q-mt-md">
        <div class="col-md-2">
          Produto:
          <q-input
            class="input-new-design"
            dense
            outlined
            v-model="filtros.produto"
          />
        </div>

        <div class="col-md-1 q-ml-sm q-mt-lg">
          <q-btn
            @click="getDados()"
            icon="filter_alt"
            no-caps
            style="background-color: #7ab9e0; border-radius: 8px; color: white"
            label="Filtrar"
          />
        </div>
      </div>

      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :loading="disable"
        dense
        :columns="columns"
        class="tabela-tamanho-fixo q-mt-md"
        row-key="name"
        hide-pagination
        :rows-per-page-options="[0]"
        @request="handleRequest"
      >
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template #body-cell-url_assinada="props">
          <q-td>
            <q-btn
              :href="props.row.url_assinada"
              target="_blank"
              type="a"
              round
              flat
              color="brand-1"
              icon="sym_o_download"
            />
          </q-td>
        </template>
        <template #body-cell-updated_at="props">
          <q-td>
            <div>
              {{
                props.row.updated_at
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}
            </div>
            <div class="q-pl-sm">
              {{ props.row.updated_at.split(" ")[1] }}
            </div>
          </q-td>
        </template>
      </q-table>
    </div>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "id",
    label: "ID Produto",
    field: (row) => row._source.id_produto,
    align: "left",
  },
  {
    name: "codigo",
    label: "Codigo",
    field: (row) => row._source.codigo,
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    field: (row) => row._source.descricao,
    align: "left",
  },
  {
    name: "ncm",
    label: "NCM",
    field: (row) => row._source.ncm,
    align: "left",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { ref, onMounted, computed, watch } from "vue";
export default {
  setup() {
    const store = useStore();
    const rows = ref([]);
    const quasar = useQuasar();
    const disable = ref(true);
    const filtros = ref({
      produto: undefined,
    });
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });
    const getDados = async () => {
      disable.value = true;
      try {
        let response = await store.dispatch("produtos/listarProdutosAcciona", {
          descricao: filtros.value.produto,
        });

        rows.value = response.data;

        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    return {
      rows,
      columns,
      getDados,
      handleRequest,
      tipoDocumento: [
        { id: 0, nome: "FICHA DE EPI", value: "ficha_epi" },
        { id: 1, nome: "RELATÓRIOS", value: "relatorio" },
        { id: 2, nome: "Consumo", value: "consumo" },
      ],
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      filtros,
      pagination,
      disable,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>
<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>
